<!--
 * @Author: xiaokun
 * @Date: 2020-04-15 16:55:07
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-04-15 17:58:02
 * @Description: 选择商品标签
 -->
<template>
  <div>
    <!-- 商品标签 -->
    <mk-select
      v-model="curCommodityTags"
      class="mr-l-10"
      placeholder="商品标签（可多选）"
      multiple
      clearable
      filterable
      width="200px"
      @change="onSelectChange"
    >
      <mk-option
        v-for="item in commodityTagsOptions"
        :key="item._id"
        :label="item.name"
        :value="item.name"
      >
      </mk-option>
    </mk-select>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  model: {
    event: 'change', prop: 'commodityTags'
  },
  props: {
    commodityTags: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      curCommodityTags: this.commodityTags,
      commodityTagsOptions: []
    }
  },
  watch: {
    commodityTags (val) {
      this.curCommodityTags = val
    }
  },
  created () {
    this.pCommodityTagGet()
  },
  methods: {
    // 获取全部商品标签
    async pCommodityTagGet () {
      let res = await CONVERSATIONAPIS.CommodityTagApi.pCommodityTagGet({})
      if (res.success) {
        this.commodityTagsOptions = res.data.data
      }
    },
    // 下拉框选择时候
    onSelectChange (val) {
      this.$emit('change', val)
    }
  }
}
</script>
